import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import * as servicesApi from '../../../api/services/servicesApi';

import hero from '../../../images/rates/PEWI-201 1.webp';
import insuranceAllLogo from '../../../images/rates/insurance-all-logo.png';

import './Rates.css';

const Rates = () => {
  const [service, setService] = useState([]);
  const location = useLocation();
  const directBillingRef = useRef(null);

  useEffect(() => {
    const getAllServices = async () => {
      const services = await servicesApi.getServices();
      setService(services);
    };
    getAllServices();
  }, []);

  useEffect(() => {
    if (location.hash === '#direct-billing' && directBillingRef.current) {
      directBillingRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location, service]);

  return (
    <div className='rates-page-container'>
      <div className='hero-img-container'>
        <img src={hero} alt='' className='rates-hero-img' />
      </div>
      <div className='rates'>
        <div>
          <h1 className='rates__title'>RATES</h1>
        </div>
        <div>
          <p className='rates__subtitle'>
            Find our most recent rates for our services listed below
          </p>
        </div>
        <div className='rates-section'>
          {service &&
            service.map((s, i) =>
              s.rates.length ? (
                <div key={i} className='rates__treatment'>
                  <div>
                    <div className='treatment__title'>{s.title}</div>
                    <div>
                      {s.rates.map((r, j) => (
                        <div key={j} className='treatment__single'>
                          <div className='treatment__name__dot'>
                            <div className='treatment__name'>
                              <span>{r.name}</span>
                            </div>
                            <span className='treatment__dot'>
                              {'.'.repeat(200)}
                            </span>
                          </div>
                          <div className='treatment__price'>
                            $
                            {r.price
                              ? r.price.toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : 0}
                            {r.is_hst ? '+HST' : ''}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null,
            )}
        </div>

        <section ref={directBillingRef} id='direct-billing'>
          <div>
            <h1 className='rates__title'>DIRECT BILLING</h1>
            <p className='rates__subtitle'>
              We bill directly to the following insurance providers:
            </p>
          </div>
          <div className='insurance-container'>
            <img src={insuranceAllLogo} alt='' className='insurance' />
          </div>
        </section>
      </div>
    </div>
  );
};

export default Rates;
